import React from 'react';
import { StyleSheet, TouchableWithoutFeedback, View } from '../base_components';

const styles = StyleSheet.create({
  dialogOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.7)',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cover: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  dialog: {
    backgroundColor: 'white',
    borderRadius: '0.5rem',
  },
});

type Props = {
  style?: any;
  outerStyle?: any;
  onOutsidePress?: () => void;
};

export default class DialogOverlay extends React.PureComponent<Props> {
  render() {
    const { style, outerStyle, onOutsidePress } = this.props;
    return (
      <View style={[styles.dialogOverlay, outerStyle]}>
        <TouchableWithoutFeedback style={styles.cover} onPress={onOutsidePress}>
          <View style={styles.cover} />
        </TouchableWithoutFeedback>
        <View style={[styles.dialog, style]}>{this.props.children}</View>
      </View>
    );
  }
}
